export default __webpack_public_path__ + "static/card_2-0ac46614f3cc9bf0f6e0137c4f927202.png";